var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.314 4.008c.904.28 1.614 1.101 1.856 2.147.438 1.893.44 5.845.44 5.845s0 3.952-.44 5.845c-.242 1.046-.952 1.867-1.856 2.147-1.637.508-8.205.508-8.205.508s-6.567 0-8.204-.508c-.904-.28-1.615-1.101-1.857-2.147C1.61 15.952 1.61 12 1.61 12s0-3.952.44-5.845C2.29 5.109 3 4.288 3.904 4.008 5.542 3.5 12.11 3.5 12.11 3.5s6.568 0 8.205.508M15.623 12l-5.716 3.3V8.7z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;